module.exports = __webpack_public_path__ + "static/media/heco-icon.1febb660.jpg";